import React from 'react';
import LogoDPC from "../../img/dpc-logo-mini.png";
import SvgIconDPC from "../dpc-svg-icon";

export default class DpcFooter extends React.Component {

    constructor(props) {
        super(props);
        this.setCookie = this.setCookie.bind(this);
        this.state = {
            checkCookie: typeof document !== `undefined` && !document.cookie.match(/^(.*;)?\s*cookies_consent\s*=\s*[^;]+(.*)?$/),
            bodyPrivacy: "",
            privacyId: 0,
            bodyTerms: "",
            termsId: 0
        }
    }

    componentDidMount() {
        this.getTerms(this.props.lang);
        this.getPrivacyPolicy(this.props.lang);
    }


    async getTerms(lang) {
        let response = await fetch(process.env.ENDPOINT_GESTIONE_CONSENSI + '/terms?portale=4', {
            method: 'GET',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            }
        });

        if (response.ok) {
            let json = await response.json();
            let consenso = JSON.parse(json[0].consenso);
            this.setState({
                bodyTerms: lang === 'it' ? consenso.ita : consenso.eng,
                termsId: json[0].id
            })
        }
    }

    async getPrivacyPolicy(lang) {
        let response = await fetch(process.env.ENDPOINT_GESTIONE_CONSENSI + '/privacy?portale=4', {
            method: 'GET',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            }
        });

        if (response.ok) {
            let json = await response.json();
            let consenso = JSON.parse(json[0].consenso);
            this.setState({
                bodyPrivacy: lang === 'it' ? consenso.ita : consenso.eng,
                privacyId: json[0].id
            })
        }
    }

    getDomain() {
        if (typeof window !== `undefined`) {
            const hostnameArray = window.location.hostname.split('.');
            if (hostnameArray.length === 3) {
                const numberOfSubdomains = hostnameArray.length - 2;
                return hostnameArray.length === 2 ? window.location.hostname : hostnameArray.slice(numberOfSubdomains).join('.')
            } else {
                const numberOfSubdomains = hostnameArray.length - 3;
                return hostnameArray.length === 1 ? window.location.hostname : hostnameArray.slice(numberOfSubdomains).join('.')
            }
        }
    }


    setCookie(check) {
        if (typeof document !== `undefined`) {
            if (document.cookie.indexOf('cookies_consent=true') >= 0 && !check) {
                document.cookie = 'cookies_consent=; Path=/; Expires=' + new Date().toUTCString() + ';';
            }
            var date = new Date();
            date.setTime(date.getTime() + (90 * 24 * 60 * 60 * 1000));
            const expires = "; expires=" + date.toUTCString();
            document.cookie = "cookies_consent=" + (check ? "true" : "false") + expires + ";domain=" + this.getDomain() + "; path=/; SameSite=Lax";
            console.log("cookies_consent=" + (check ? "true" : "false") + expires + ";domain=" + this.getDomain() + "; path=/; SameSite=Lax");
            window.location.reload();
        }
    }

    geFooterLinkBasePath = () => {
        if (this.props.portaleUrl) {
            return `${this.props.portaleUrl}/${this.props.lang}`
        } else {
            return `/${this.props.lang}`
        }
    }

    getCookie = () => {
        if (typeof document !== `undefined`) {
            return !!document.cookie.indexOf('cookies_consent=true') >= 0;
        }
        return false;
    }

    isHomepage(){
        let isHomePageAD = false;
        const currentLocationPathname = this.props.currentPathname;

       if (currentLocationPathname) {
            const expectedPath = `/${this.props.lang}/`;
            const alternativePath = `/${this.props.lang}`;

            isHomePageAD = currentLocationPathname === expectedPath || currentLocationPathname === alternativePath;
        }
        return isHomePageAD
    }

    render() {

        const showExtraFooter = this.isHomepage();
        return (
            <>
                <footer className="it-footer" role="contentinfo" id="footer" tabIndex="-1">
                  
                    <div className={showExtraFooter ? "it-footer-share-social img-footer-bg" : "it-footer-share-social img-footer-bg is-hidden"}>  
                        <div className="container customPadding">
                            <div className="px-custom pt-5"> 
                                <div className="footer-content-wrapper">
                                    {this.props.lang === 'it'?(
                                        <a href="https://www.iononrischio.gov.it/it/" target="_blank" rel="noopener noreferrer" className="btn-io-non-rischio mr-3">
                                        Visita "Io non rischio" 
                                        </a> 
                                    ):(
                                        <a href="https://www.iononrischio.gov.it/en/" target="_blank" rel="noopener noreferrer" className="btn-io-non-rischio mr-3">
                                                Go to "I don't take risks"
                                        </a>
                                        
                                    )}
                                    <p className="footer-text mb-0 ">{this.props.lang === 'it' ? 'Per scoprire le buone pratiche di protezione civile' : 'To discover good civil protection practices'}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="it-footer-share-social  it-footer-share-social-attimodecisivo">
                        <div className="container customPadding">
                            <div className="px-custom pb-2">
                                <div className="partners">
                                        <ul>
                                            <li>                                            
                                                <a href="https://www.protezionecivile.gov.it/"
                                                   title="Dipartimento della Protezione Civile"
                                                   target="_blank" rel="noopener">
                                                    <img src={LogoDPC} alt=""/>
                                                </a>
                                            </li> 

                                            <li className="alignTextDPC">
                                                <p>Presidenza del Consiglio dei Ministri</p>

                                                <p>Dipartimento della Protezione Civile</p>
                                            </li> 
                                        </ul>
                                </div>

                                <div className="it-socials d-flex justify-content-end customDivFooterSocial">
                                    <span>{this.props.lang === 'it' ? 'Seguici su' : "Follow us"}</span>

                        
                                    <ul className="footerCustomMarginAD">
                                        <li className="customLiFooterAD">
                                           <a href="https://www.tiktok.com/@attimodecisivo?_t=ZN-8xszCgoxDDq&_r=1"
                                                title="Profilo TikTok Attimo decisivo"
                                                target="_blank" rel="noreferrer">
                                                <SvgIconDPC name={'tiktok'} color={"#fff"}  className={'customIconTTFooter'} />
                                            </a>
                                        </li>

                                          <li>
                                            <a href="https://www.instagram.com/attimodecisivo/?igsh=MWcxd2lkNGZsZDRnYQ%3D%3D"
                                               title="Profilo Instagram Attimo decisivo"
                                               target="_blank" rel="noreferrer">
                                                <SvgIconDPC name={'instagram'} color={"#fff"} />
                                            </a>
                                        </li>

                                          <li>
                                            <a href="https://www.youtube.com/@attimodecisivo"
                                               title="Canale YouTube Attimo decisivo"
                                               target="_blank" rel="noreferrer">
                                                <SvgIconDPC name={'youtube'} color={"#fff"} />
                                            </a>
                                        </li>
                                    </ul>
                                 
                                </div>

                            </div>
                        </div>
                    </div>

                   

                    <div className="it-footer-small-prints custom-footer-attimodecisivo clearfix">
                        <div className="container">
                            <div className="px-custom">
                                <h4 className="sr-only">Sezione Link Utili</h4>

                                <ul className="it-footer-small-prints-list list-inline d-flex flex-column flex-md-row">
                                         <li className="list-inline-item">
                                            {this.props.lang === 'it' ? (
                                                <a className="custom-a-attimodecisivo" href={"https://www.attimodecisivo.gov.it/it/pagina-base/privacy-1/"}>Privacy</a>
                                            ):(
                                                <a className="custom-a-attimodecisivo" href={"https://www.attimodecisivo.gov.it/en/pagina-base/privacy-2/"}>Privacy</a>
                                            )}
                                            </li>

                                            <li className="list-inline-item">
                                            {this.props.lang === 'it' ? ( 
                                                 <a className="custom-a-attimodecisivo" href={"https://www.attimodecisivo.gov.it/it/pagina-base/social-media-policy-1/"}>Policy Social</a>
                                            ):(
                                                <a className="custom-a-attimodecisivo" href={"https://www.attimodecisivo.gov.it/en/pagina-base/social-media-policy-2/"}>Social Privacy</a>
                                            )}
                                            </li>

                                            <li className="list-inline-item">
                                            {this.props.lang === 'it' ? ( 
                                                 <a className="custom-a-attimodecisivo" href={"https://www.attimodecisivo.gov.it/it/pagina-base/note-legali-1/"}>Note legali</a>
                                            ):(
                                                <a className="custom-a-attimodecisivo" href={"https://www.attimodecisivo.gov.it/en/pagina-base/legal-notice-1/"}>Legal notice</a>
                                            )}
                                            </li>

                                            <li className="list-inline-item"><a className="custom-a-attimodecisivo"
                                                href={'/' + this.props.lang + '/sitemap/'}>{this.props.lang === 'it' ? 'Mappa' : 'Map'}</a>
                                            </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="modal it-dialog-scrollable fade" tabindex="-1" role="dialog" id="modalPrivacyFooter"
                         aria-labelledby="modalPrivacyTitle">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title"
                                        id="modalPrivacyTitle">{this.props.lang === 'it' ? 'Politica sulla Privacy' : 'Privacy Policy'}</h5>
                                </div>

                                <div className="modal-body">
                                    <div
                                        dangerouslySetInnerHTML={{__html: this.state.bodyPrivacy ? this.state.bodyPrivacy : ''}}/>
                                </div>

                                <div className="modal-footer">
                                    <button className="btn btn-secondary btn-sm" type="button"
                                            data-dismiss="modal">{this.props.lang === 'it' ? 'Chiudi' : 'Close'}</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal it-dialog-scrollable fade" tabindex="-1" role="dialog" id="modalTermsFooter"
                         aria-labelledby="modalTermsTitle">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title"
                                        id="modalTermsTitle">{this.props.lang === 'it' ? 'Termini e condizioni' : 'Terms and conditions'}</h5>
                                </div>

                                <div className="modal-body">
                                    <div
                                        dangerouslySetInnerHTML={{__html: this.state.bodyTerms ? this.state.bodyTerms : ''}}/>

                                </div>

                                <div className="modal-footer">
                                    <button className="btn btn-secondary btn-sm" type="button"
                                            data-dismiss="modal">{this.props.lang === 'it' ? 'Chiudi' : 'Close'}</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </footer>


                {this.state.checkCookie ?
                    <div className={`cookiebar bg-dark p-4 show`}
                         aria-hidden="true">
                        <div className="container">
                            <div className="px-custom">
                                <div className="row d-flex align-items-center">
                                    <div className="col-12 col-md-9" style={{'text-align': 'justify'}}>
                                        <span className="text-white small">
                                            {this.props.lang === 'it'
                                                ? 'Questo sito utilizza cookies tecnici, cookie analytics e cookie di terze parti (altri siti e piattaforme web) per la personalizzazione della home page, il monitoraggio delle visite al sito, la condivisione dei contenuti sui social network, la compilazione automatica di moduli e/o la visualizzazione di contenuti multimediali. Per maggiori informazioni consulta la privacy policy Acconsenti all\'utilizzo di cookie di terze parti?'
                                                : 'This website uses technical and analytical cookies, also from third parties (other websites and web platforms), for the home page customization, visitor monitoring, content sharing on social networks, automatic form filling and/or multimedia content visualization. For further information please consult the privacy policy. Do you agree to the use of third party cookies?'}
                                        </span>
                                    </div>

                                    <div className="col-12 col-md-3 mt-4 mt-md-0 d-flex justify-content-end">
                                        <a className="btn btn-link"
                                           href="https://www.iononrischio.it/it/pagina-base/privacy/">Privacy policy</a>

                                        <button className="btn btn-primary mr-2" onClick={() => {
                                            this.setCookie(true)
                                        }}>{this.props.lang === 'it' ? 'Accetto' : 'I agree'}
                                        </button>

                                        <button className="btn btn-secondary mr-2 cookies-consent-reject"
                                                id="cookiesConsentReject" onClick={() => {
                                            this.setCookie(false)
                                        }}>{this.props.lang === 'it' ? 'Rifiuto' : 'I do not agree'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null}
            </>)
    }

}
